import pinbikeLogo from "./images/pinbike-logo-animato.gif";
import ugoLogo from "./images/logo_ugo.png";

/**
 * Marchi della web (white label): login, header della pagina del pinbiker e titolo della scheda.
 * Il backoffice di admin e manager resta Pin Bike in ogni caso.
 *
 * `color` e' quello dei bottoni, `accent` quello della voce attiva nella barra scura del pinbiker.
 *
 * Il marchio si sceglie dal dominio (DOMAINS); finche' un marchio non ha un dominio suo si puo'
 * forzare con ?brand=<chiave> nell'URL, che resta ricordato nel browser (?brand=pinbike lo toglie).
 */
export const BRANDS = {
    pinbike: {
        key: "pinbike",
        name: "Pin Bike",
        logo: pinbikeLogo,
        logoHeight: { login: 72, header: 40 },
        homeUrl: "https://pin.bike/",
        color: "#dd3333",
        contrastText: "#fff",
        accent: "#dd3333",
        owner: "FB Innovation",
    },
    ugo: {
        key: "ugo",
        name: "UGO",
        logo: ugoLogo,
        logoHeight: { login: 120, header: 52 },
        homeUrl: null,
        color: "#111111",
        contrastText: "#fff",
        accent: "#1a5fb4",
        owner: "UGO Platform",
    },
};

export const DEFAULT_BRAND = "pinbike";

// Dominio -> marchio. Per ora nessun dominio dedicato: UGO si apre con ?brand=ugo.
const DOMAINS = {};

const STORAGE_KEY = "pinbike.brand";

function fromQuery() {
    try {
        const value = new URLSearchParams(window.location.search).get("brand");
        if (!value) return null;
        if (BRANDS[value] && value !== DEFAULT_BRAND) {
            window.localStorage.setItem(STORAGE_KEY, value);
            return value;
        }
        window.localStorage.removeItem(STORAGE_KEY);
        return DEFAULT_BRAND;
    } catch (e) {
        return null;
    }
}

function fromStorage() {
    try {
        const value = window.localStorage.getItem(STORAGE_KEY);
        return BRANDS[value] ? value : null;
    } catch (e) {
        return null;
    }
}

/** Marchio corrente: dominio, poi ?brand=, poi quello ricordato, poi Pin Bike. */
export function getBrand() {
    const key = DOMAINS[window.location.hostname] || fromQuery() || fromStorage() || DEFAULT_BRAND;
    return BRANDS[key] || BRANDS[DEFAULT_BRAND];
}
